export const getFromStorage = (path, expectObject = false) => {
  let toReturn = localStorage.getItem(path);
  if (toReturn && expectObject) {
    toReturn = JSON.parse(toReturn);
  }
  return toReturn;
};

export const setInStorage = (path, data) => {
  let toSet = data;
  if (typeof data === 'object' || Array.isArray(data)) {
    toSet = JSON.stringify(data);
  }
  localStorage.setItem(path, toSet);
};

export const removeFromstorage = (key) => {
  localStorage.removeItem(key);
};
